import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/resilience')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/resilience', ...ROUTE_META['/platform/resilience'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Resilience', path: '/platform/resilience' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/resilience', ...ROUTE_META['/platform/resilience'] })),
    ],
  }),
});
